import React from "react";
import {
  LoginButtonHeader,
  LogoContainer,
  NavbarContainer,
  NavItem,
} from "./roleHeader.styled";
import { env } from "../../.env";
import { CustomButton } from "../buttons/index.styled";
import { Link } from "react-router-dom";
const RoleHeader = () => {
  const linkHandler = () => {
    window.location.href = env.REACT_APP_PANEL_REDIRECT;
  };
  return (
    <NavbarContainer className="container">
      <LogoContainer>
        <h2>
          <span>آوا</span>نــگـــــار
        </h2>
      </LogoContainer>
      <NavItem>
        <Link to="/">خانه</Link>
      </NavItem>
      <LoginButtonHeader>
        <CustomButton
          width="138px"
          height="48px"
          radius="2px"
          background="#12A46F"
          borderColor="#12A46F"
          backgroundHover="#FFFFFF"
          borderColorHover="#12A46F"
          colorHover="#12A46F"
          fontWeight="700"
          onClick={linkHandler}
        >
          ورود به حساب
        </CustomButton>
      </LoginButtonHeader>
    </NavbarContainer>
  );
};

export default RoleHeader;
